import { __awaiter, __generator } from "tslib";
import { useQuery } from '@office-start/data-fetching';
import { useCallback, useMemo } from 'react';
import { getQueryKey } from '../getQueryKey';
import { useRecommendedDataProvider } from './useRecommendedDataProvider';
export function useRecommendedData(providerType, fileType) {
    var _this = this;
    var dataProvider = useRecommendedDataProvider(providerType);
    var queryKey = useMemo(function () {
        return getQueryKey(providerType, fileType);
    }, [providerType, fileType]);
    var queryFunction = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, dataProvider === null || dataProvider === void 0 ? void 0 : dataProvider.getRecommendedData(fileType, queryKey)];
        });
    }); }, [dataProvider, fileType, queryKey]);
    // TODO: 'enabled': using a more flexible dependency resolving method which can handle different requirement from different provider.
    return useQuery(queryKey, queryFunction, {
        staleTime: Infinity,
        cacheTime: Infinity,
        enabled: dataProvider !== undefined,
    });
}
//# sourceMappingURL=useRecommendedData.js.map